import { render, staticRenderFns } from "./walletBind.vue?vue&type=template&id=50d741c5&scoped=true"
import script from "./walletBind.vue?vue&type=script&lang=js"
export * from "./walletBind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d741c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d741c5')) {
      api.createRecord('50d741c5', component.options)
    } else {
      api.reload('50d741c5', component.options)
    }
    module.hot.accept("./walletBind.vue?vue&type=template&id=50d741c5&scoped=true", function () {
      api.rerender('50d741c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/other/walletBind.vue"
export default component.exports